import React from 'react';
import {
  NPSContainer,
  NPSTopWrapper,
  NPSBottomWrapper,
  RadioButton,
  ButtonText,
} from './elements';

type Props = {
  readonly className?: string;
  readonly small?: boolean;
  readonly onClick: (number: number) => void;
  readonly numberSelected: number;
};

export default function NpsRadioButtons({
  className,
  small,
  onClick,
  numberSelected,
}: Props): React.ReactElement {
  return (
    <NPSContainer className={className} small={small}>
      <NPSTopWrapper>
        {Array.from(new Array(6), (x, i) => i).map(number => (
          <RadioButton
            key={`nps-score-${number}`}
            onClick={() => onClick(number)}
            selected={number === numberSelected}
          >
            <ButtonText selected={number === numberSelected}>
              {number}
            </ButtonText>
          </RadioButton>
        ))}
      </NPSTopWrapper>
      <NPSBottomWrapper small={small}>
        {Array.from(new Array(5), (x, i) => i + 6).map(number => (
          <RadioButton
            key={`nps-score-${number}`}
            onClick={() => onClick(number)}
            selected={number === numberSelected}
          >
            <ButtonText selected={number === numberSelected}>
              {number}
            </ButtonText>
          </RadioButton>
        ))}
      </NPSBottomWrapper>
    </NPSContainer>
  );
}
